import { styled } from '@mui/material';

import { Divider } from '../../Divider';
import { useMenuContext } from '../hooks/useMenuContext';

const StyledDivider = styled(Divider)<{ variant?: 'compact' }>(
  ({ theme, variant }) => ({
    margin:
      variant === 'compact' ? 0 : `${theme.spacing(2)} -${theme.spacing(1)}`,
    width: 'auto',
    borderBottomWidth: 2,
    borderColor: 'var(--stroke-stroke-primary-color)',
  })
);

export type ContextMenuDividerProps = {
  className?: string;
};

export const ContextMenuDivider = ({ className }: ContextMenuDividerProps) => {
  const { variant } = useMenuContext();

  return <StyledDivider className={className} variant={variant} />;
};
